import { User } from "@prisma/client";
import { create } from "zustand";
import { devtools, persist, createJSONStorage } from "zustand/middleware";
interface State {
  user: User | null;
}

interface Action {
  setUser: (user: User | null) => void;
}

const useUser = create<State & Action>()(
  devtools(
    persist(
      (set): State & Action => ({
        user: null,
        setUser: (user: User | null) => set({ user }),
      }),
      {
        name: "mage-x-zustand-user-store",
        version: 1,
        storage: createJSONStorage(() => window.localStorage),
      },
    ),
  ),
);

export default useUser;
